import { render, staticRenderFns } from "./SectorSpecificDataPanel.vue?vue&type=template&id=3b854134&scoped=true&"
import script from "./SectorSpecificDataPanel.vue?vue&type=script&lang=ts&"
export * from "./SectorSpecificDataPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b854134",
  null
  
)

export default component.exports